// import React, { useContext, useEffect, useState } from 'react'
// import AdminContext from '../../StateContext/Application';
// import { apiurl } from '../../../../path';
// import { useLanguage } from '../../../../lang/langcontext/LanguageContext';
// const TechnicalSanctionOutwards = () => {
//         const { language, toggleLanguage, t } = useLanguage();
//     const context = useContext(AdminContext)
//     const { TechnicalOutwards } = context
//     const [proposallist, setProposalList] = useState([])
//     const [searchTerm, setSearchTerm] = useState('');
//     const budgetEstimation = proposallist;
//     const [filteredBills, setFilteredBills] = useState([]);
//     const [currentPage, setCurrentPage] = useState(1);
//     const billsPerPage = 10;
//     const [selectedProposal, setSelectedProposal] = useState(null);
//     const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
//     const indexOfLastBill = currentPage * billsPerPage;
//     const indexOfFirstBill = indexOfLastBill - billsPerPage;
//     const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

//     const headerStyle = {
//         padding: "12px 16px",
//         whiteSpace: "nowrap",
//         borderRight: "1px solid #e0e0e0",
//         textTransform: "capitalize",
//     };
//     const proposalEstimate = async () => {
//         let data = await TechnicalOutwards("Technical")
//         setProposalList(data)
//         console.log("working for techinicalcount",data)
//     }

//     useEffect(() => {
//         proposalEstimate()
//     }, [])

//     useEffect(() => {
//         const lowerSearchTerm = searchTerm.toLowerCase();
//         const filtered = budgetEstimation.filter(bill =>
//             Object.values(bill).some((val) =>
//                 (val || '').toString().toLowerCase().includes(lowerSearchTerm)
//             )
//         );
//         setFilteredBills(filtered);
//         setCurrentPage(1);
//     }, [searchTerm, budgetEstimation]);

//     const selectedBillDetails = (BillID) => {
//         const result = budgetEstimation
//             .filter(item => item.TS_ID == BillID)
//             .map(item => ({
//                 "Technical Sanction UID": item.TS_ID,
//                 "Technical Sanction Number": item.TechnicalSanctionNo,
//                 "Head Code": item.HeadCode,
//                 "Proposal Name": item.WorkName,
//                 "Proposal Year": item.SanctionYear,
//                 "GR UID": item.GR_UID,
//                 "Constituency Name": item.ConstituencyName,
//                 "District": item.District,
//                 "Taluka": item.Taluka,
//                 "Gram Panchayat": item.GramPanchayat,
//                 "Type of Work": item.TypeofWork,
//                 "Technical Sanction Amount": item.TechnicalSanctionAmt,
//                 "Technical Sanction Copy": item.TechnicalSanctionCopy,
//                 "Date": new Date(item.Date).toLocaleString(),
//             }));

//         console.log("------------------", result)
//         setSelectedProposal(result[0]);
//     };

//      return (
//         <>
//             {
//                 false &&
//                 <div style={{ overflowX: "hidden", display: 'grid', justifyContent: "center", padding: "20px 0px", height: '91vh', overflowY: "auto" }}>
//                     <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "78vw", }}>
//                         <h4 >{t("Technical Sanction Outwards")}</h4>
//                         <input
//                             type="text"
//                             placeholder={t("Search")}
//                             onChange={(e) => setSearchTerm(e.target.value)}
//                             value={searchTerm}
//                             style={{ width: "250px", padding: "8px 12px", border: "1px solid #ccc", borderRadius: "5px", backgroundColor: 'aliceblue', fontSize: "14px", marginRight: "10px" }}
//                         />
//                     </div>

//                     <div style={{ display: "grid", justifyContent: "center", width: "80vw", maxWidth: "100%" }}>
//                         <div style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', display: 'flex', width: '75vw', overflowX: "auto", border: '1px solid #3b409e' }}>
//                             <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "1200px" }}>
//                                 <thead>
//                                     <tr style={{ color: 'white', border: 'none', height: '3.5rem' }}>
//                                         <th style={{ padding: '8px' }} rowSpan={2}>{t("Head Code")}</th>
//                                         <th style={{ padding: '8px' }} rowSpan={2}>{t("Year")}</th>
//                                         <th style={{ padding: '8px' }} rowSpan={2}>{t("Work Name")}</th>
//                                         <th style={{ padding: '8px' }} colSpan={3}>{t("Approved by")}</th>
//                                         {/* <th style={{ padding: '8px' }}>Details</th> */}
//                                     </tr>
//                                     <tr style={{ color: 'white', border: 'none', height: '3rem' }}>
//                                         <th style={{ padding: '8px', borderLeft: '1px solid white', borderRight: '1px solid white' }}>{t("RDD Checker")}</th>
//                                         <th style={{ padding: '8px', borderRight: '1px solid white' }}>{t("RDD Section Officer")}</th>
//                                         <th style={{ padding: '8px', borderLeft: '1px solid white', borderRight: '1px solid white' }}>{t("Deputy /Joint Secretary")}</th>
//                                     </tr>

//                                 </thead>

//                                 {/* {currentBills?.length === 0 ? (
//                                     <tr>
//                                         <td colSpan="10" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
//                                             No data available
//                                         </td>
//                                     </tr>
//                                 ) : (
//                                     currentBills?.map((proposal, index) => {
//                                         const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                         return (
//                                             <tbody key={proposal.ID || index}>
//                                                 <tr style={{ borderBottom: '1px solid #3b409e', backgroundColor: bgColor }}>
//                                                     <td style={{ padding: '8px' }}>{proposal.HeadCode}</td>
//                                                     <td style={{ padding: '8px' }}>{proposal.SanctionYear}</td>
//                                                     <td style={{ padding: '8px' }}>{proposal.WorkName}</td>
//                                                     <td style={{ padding: '8px', textAlign: 'center', borderRight: '1px solid #3b409e' }}>
//                                                         {proposal.Approvance1 === 'true' ? '✅' : proposal.Approvance1 === 'false' ? '❌' : '-'}
//                                                     </td>
//                                                     <td style={{ padding: '8px', textAlign: 'center', borderRight: '1px solid #3b409e' }}>
//                                                         {proposal.Approvance2 === 'true' ? '✅' : proposal.Approvance2 === 'false' ? '❌' : '-'}
//                                                     </td>
//                                                     <td style={{ padding: '8px', textAlign: 'center' }}>
//                                                         {proposal.Approvance3 === 'true' ? '✅' : proposal.Approvance3 === 'false' ? '❌' : '-'}
//                                                     </td>
//                                                     <td style={{ padding: '8px' }}>{proposal.Proposal_copy}</td>
//                                                     <td style={{ padding: '8px', textAlign: 'center' }}>
//                                                         <button
//                                                             onClick={() => setSelectedProposal(proposal)}
//                                                             style={{
//                                                                 cursor: 'pointer',
//                                                                 backgroundColor: '#0098d5',
//                                                                 color: 'white',
//                                                                 border: 'none',
//                                                                 padding: '5px 10px',
//                                                                 borderRadius: '4px'
//                                                             }}
//                                                         >
//                                                             View
//                                                         </button>
//                                                     </td>
//                                                 </tr>

//                                             </tbody>
//                                         );
//                                     })
//                                 )} */}
//                             </table>
//                         </div>
//                     </div>

//                     <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0px 2.5rem', height: '3rem', alignItems: 'center' }}>
//                         <div>
//                             <p>{t("Showing")} {currentBills?.length} {t("of")} {proposallist?.length} {t("entries")}</p>
//                         </div>
//                         <div style={{ display: 'flex', alignItems: 'center' }}>
//                             <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
//                                 style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px' }}>&laquo;</button>
//                             <button onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}
//                                 style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', borderLeft: "none" }}>&lt;</button>
//                             <button
//                                 style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '24px', width: '3rem', border: '1px solid lightgrey', borderLeft: "none" }}>
//                                 {currentPage}
//                             </button>
//                             <button onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === totalPages}
//                                 style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', borderLeft: "none" }}>&gt;</button>
//                             <button onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages}
//                                 style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', borderLeft: "none" }}>&raquo;</button>
//                         </div>
//                     </div>
//                     {selectedProposal && (
//                         <div
//                             onClick={() => setSelectedProposal(null)}
//                             style={{
//                                 position: 'fixed',
//                                 top: 0, left: 0,
//                                 width: '100vw',
//                                 height: '100vh',
//                                 backgroundColor: 'rgba(0,0,0,0.5)',
//                                 display: 'flex',
//                                 justifyContent: 'center',
//                                 alignItems: 'center',
//                                 zIndex: 9999,
//                             }}
//                         >
//                             <div
//                                 onClick={(e) => e.stopPropagation()}
//                                 style={{
//                                     backgroundColor: 'white',
//                                     padding: '20px',
//                                     borderRadius: '8px',
//                                     maxWidth: '600px',
//                                     width: '90%',
//                                     maxHeight: '80vh',
//                                     overflowY: 'auto',
//                                     boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
//                                     position: 'relative'
//                                 }}
//                             >
//                                 <h3>{t("Proposal Details")}</h3>
//                                 <button
//                                     onClick={() => setSelectedProposal(null)}
//                                     style={{
//                                         position: 'absolute',
//                                         top: '10px',
//                                         right: '10px',
//                                         background: 'transparent',
//                                         border: 'none',
//                                         fontSize: '20px',
//                                         cursor: 'pointer',
//                                     }}
//                                 >
//                                     &times;
//                                 </button>
//                                 <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//                                     <tbody>
//                                         {Object.entries(selectedProposal).map(([key, value]) => (
//                                             <tr key={key} style={{ borderBottom: '1px solid #ddd' }}>
//                                                 <td style={{ fontWeight: 'bold', padding: '8px', width: '40%', backgroundColor: '#f0f0f0' }}>{key}</td>
//                                                 <td style={{ padding: '8px' }}>{value === null ? '-' : value.toString()}</td>
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </table>
//                             </div>
//                         </div>
//                     )}
//                 </div>
//             }

//             <div className='col-12 pb-5' style={{ backgroundColor: "#EFF3F8", height: "90vh", overflowX: "hidden", overflowY: "scroll" }}>
//                 <div className="col-11 m-auto">
//                     <div className="col-12 ">
//                         <div className='col-12 px-4 mb-4 mt-3' style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>

//                             <h5 className='my-auto fw-bold'>
//                                 <img src="/Technical-Sanction-Outwards-Blue 64.png" alt="TechnicalSanctionOutwards" style={{ width: "24px", height: "24px" }} className='my-auto me-1' />
//                                 <span className='my-auto '>{t("Technical Sanction Outwards")}</span>
//                             </h5>
//                             <div style={{ position: "relative", width: "250px", marginRight: "10px" }}>
//                                 <img
//                                     src="/Search32.png"
//                                     alt="Search Icon"
//                                     style={{
//                                         position: "absolute",
//                                         top: "50%",
//                                         left: "10px",
//                                         transform: "translateY(-50%)",
//                                         width: "16px",
//                                         height: "16px",
//                                         opacity: 0.6
//                                     }}
//                                 />
//                                 <input
//                                     type="text"
//                                     placeholder={t("Search Here")}
//                                     onChange={(e) => setSearchTerm(e.target.value)}
//                                     value={searchTerm}
//                                     style={{
//                                         width: "100%",
//                                         padding: "8px 12px 8px 32px",
//                                         border: "1px solid #ccc",
//                                         borderRadius: "8px",
//                                         backgroundColor: "#f1f6fc",
//                                         fontSize: "14px",
//                                         color: "#333",
//                                         boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
//                                         outline: "none"
//                                     }}
//                                 />
//                             </div>
//                         </div>

//                         <div className="col-12 pb-5">
//                             <div className='m-auto mb-3' style={{ backgroundColor: "white", padding: "40px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%",maxWidth:"100%",overflowX:"hidden" }}>
//                                 <div className='col-12 tableDesign' style={{ background: '#2C78DB', overflowX: 'scroll' }}>
//                                     <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
//                                         <thead>
//                                             <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
//                                                 <th style={headerStyle} rowSpan={2} colSpan={1}>{t("Sr.No")}</th>
//                                                 <th style={{ minWidth: "150px", padding: "8px" }} rowSpan={2} colSpan={1}>{t("Work Name")}</th>
//                                                 <th style={{ minWidth: "150px", padding: "8px" }} rowSpan={2} colSpan={1}>{t("Head Code")}</th> {/* changed from 9 to 7 */}
//                                                 <th style={headerStyle} rowSpan={2} colSpan={1}>{t("Technical Sanction UID")}</th>
//                                                 <th style={headerStyle} rowSpan={2} colSpan={1}>{t("MHUID Number")}</th>
//                                                 <th style={headerStyle} rowSpan={2} colSpan={1}>{t("GR UID")}</th>
//                                                 <th style={headerStyle} rowSpan={2} colSpan={1}>{t("Year")}</th>
//                                                 <th style={headerStyle} rowSpan={2} colSpan={1}>{t("Constituency Name")}</th>
//                                                 <th style={headerStyle} rowSpan={2} colSpan={1}>{t("District")}</th>
//                                                 <th style={headerStyle} rowSpan={2} colSpan={1}>{t("Taluka")}</th>
//                                                 <th style={headerStyle} rowSpan={2} colSpan={1}>{t("Gram Panchayat")}</th>
//                                                 <th style={{ minWidth: "150px", padding: "8px" }} rowSpan={2} colSpan={1}>{t("Type of Work")}</th>
//                                                 <th style={headerStyle} rowSpan={2} colSpan={1}>{t("Technical Sanction Amount")}</th>
//                                                 <th style={headerStyle} rowSpan={2} colSpan={1}>{t("Technical Sanction Copy")}</th>
//                                                 <th style={{ minWidth: "150px", padding: "8px" }} rowSpan={2} colSpan={1}>{t("Date")}</th>
//                                                 <th style={headerStyle} colSpan={2}>{t("Approved by")}</th> {/* changed from 9 to 7 */}
//                                                 {/* <th style={{ width: "12%", textAlign: "center", border: "1px solid white" }} colSpan={1} rowSpan={2}>Details</th> */}
//                                             </tr>
//                                             <tr style={{ color: 'white', border: 'none', height: '3rem' }}>
//                                                 <th style={headerStyle}>{t("Deputy Engineer")}</th>
//                                                 <th style={headerStyle}>{t("Executive Engineer")}</th>
//                                             </tr>
//                                         </thead>

//                                         <tbody >
//                                             {currentBills?.length === 0 ? (
//                                                 <tr>
//                                                     <td colSpan="10" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
//                                                         {t("No data available")}
//                                                     </td>
//                                                 </tr>
//                                             ) : (
//                                                 currentBills?.map((proposal, index) => {
//                                                     const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                                     return (
//                                                         <tr style={{ backgroundColor: bgColor }} key={index}>
//                                                             <td style={{ padding: '8px 8px' }}>{(indexOfFirstBill + index + 1)}</td>
//                                                             <td className='fw-bold' style={{ fontSize: "12px", padding: "5px" }}>{proposal.WorkName}</td>
//                                                             <td style={{ padding: '8px 8px' }}>{(proposal.HeadCode)}</td>
//                                                             <td style={{ padding: '8px 8px' }}>{(proposal.TS_ID)}</td>
//                                                             <td style={{ padding: '8px 8px' }}>{(proposal.TechnicalSanctionNo)}</td>
//                                                             <td style={{ padding: '8px 8px' }}>{(proposal.GR_UID)}</td>
//                                                             <td style={{ padding: '8px 8px' }}>{(proposal.SanctionYear)}</td>
//                                                             <td style={{ padding: '8px 8px' }}>{(proposal.ConstituencyName)}</td>
//                                                             <td style={{ padding: '8px 8px' }}>{(proposal.District)}</td>
//                                                             <td style={{ padding: '8px 8px' }}>{(proposal.Taluka)}</td>
//                                                             <td style={{ padding: '8px 8px' }}>{(proposal.GramPanchayat)}</td>
//                                                             <td style={{ padding: '8px 8px' }}>{(proposal.TypeofWork)}</td>
//                                                             <td style={{ padding: '8px 8px' }}>{(proposal.TechnicalSanctionAmt)}</td>
//                                                             <td style={{ padding: '8px' }}>
//                                                                 {proposal.TechnicalSanctionCopy ? (
//                                                                     <a href={`${apiurl}/TechincalSactionCopy/${proposal.TechnicalSanctionCopy}`} target="_blank" rel="noreferrer">{proposal.TechnicalSanctionCopy}</a>
//                                                                 ) : (
//                                                                     <p className='text-danger my-auto fw-bold'>{t("No File")}</p>
//                                                                 )
//                                                                 }
//                                                             </td>
//                                                             <td style={{ padding: '8px 8px' }}>{new Date(proposal.Date).toLocaleString()}</td>

//                                                             <td style={{ padding: '8px', textAlign: 'center' }}>
//                                                                 {proposal.Approvance2 === 'true' ? (<div className='m-auto'
//                                                                     style={{
//                                                                         width: '20px',
//                                                                         height: '20px',
//                                                                         borderRadius: '6px',
//                                                                         backgroundColor: '#16C60C',
//                                                                         border: 'none',
//                                                                         display: 'flex',
//                                                                         justifyContent: 'center',
//                                                                         alignItems: 'center',
//                                                                         fontSize: '13px',
//                                                                         color: 'white',
//                                                                         boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                     }}
//                                                                 >
//                                                                     ✓
//                                                                 </div>) : proposal.Approvance2 === 'false' ? (<div
//                                                                     className='m-auto'
//                                                                     style={{
//                                                                         width: '20px',
//                                                                         height: '20px',
//                                                                         borderRadius: '6px',
//                                                                         backgroundColor: '#dc2626',
//                                                                         border: 'none',
//                                                                         display: 'flex',
//                                                                         justifyContent: 'center',
//                                                                         alignItems: 'center',
//                                                                         fontSize: '13px',
//                                                                         color: 'white',
//                                                                         boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                     }}
//                                                                 >
//                                                                     ✕
//                                                                 </div>) : '-'}
//                                                             </td>
//                                                             <td style={{ padding: '8px', textAlign: 'center' }}>
//                                                                 {proposal.Approvance3 === 'true' ? (<div className='m-auto'
//                                                                     style={{
//                                                                         width: '20px',
//                                                                         height: '20px',
//                                                                         borderRadius: '6px',
//                                                                         backgroundColor: '#16C60C',
//                                                                         border: 'none',
//                                                                         display: 'flex',
//                                                                         justifyContent: 'center',
//                                                                         alignItems: 'center',
//                                                                         fontSize: '13px',
//                                                                         color: 'white',
//                                                                         boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                     }}
//                                                                 >
//                                                                     ✓
//                                                                 </div>) : proposal.Approvance3 === 'false' ? (<div
//                                                                     className='m-auto'
//                                                                     style={{
//                                                                         width: '20px',
//                                                                         height: '20px',
//                                                                         borderRadius: '6px',
//                                                                         backgroundColor: '#dc2626',
//                                                                         border: 'none',
//                                                                         display: 'flex',
//                                                                         justifyContent: 'center',
//                                                                         alignItems: 'center',
//                                                                         fontSize: '13px',
//                                                                         color: 'white',
//                                                                         boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
//                                                                     }}
//                                                                 >
//                                                                     ✕
//                                                                 </div>) : '-'}
//                                                             </td>

//                                                             {/* <td style={{ padding: '8px' }}>{proposal.Proposal_copy}</td> */}
//                                                             {/* <td>
//                                                                 <button
//                                                                     className='m-auto'
//                                                                     onClick={() => selectedBillDetails(proposal.TS_ID)}
//                                                                     style={{
//                                                                         cursor: 'pointer',
//                                                                         background: "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
//                                                                         color: 'white',
//                                                                         border: 'none',
//                                                                         padding: '6px 20px',
//                                                                         borderRadius: '4px',
//                                                                         fontSize: "12px",
//                                                                         display: "flex",
//                                                                         justifyContent: "center",
//                                                                         alignItems: 'center',
//                                                                         width: "80%"
//                                                                     }}
//                                                                 >
//                                                                     <img src="/view32.png" alt="view" className='me-1' style={{ width: "12px", height: "12px" }} />
//                                                                     View
//                                                                 </button>
//                                                             </td> */}
//                                                         </tr>

//                                                     );
//                                                 })
//                                             )}
//                                         </tbody>
//                                     </table>

//                                 </div>
//                                 <div className='col-12 mt-4'>
//                                     <div className="row">
//                                         <div className='col-6'>
//                                             <p className="text-gray-600" style={{ fontSize: "14px" }}>{t("Showing")} {filteredBills.length>0?indexOfFirstBill + 1:0} {t("to")} {Math.min(indexOfLastBill, proposallist?.length)} {t("of")} {proposallist?.length} {t("entries")}</p>
//                                         </div>
//                                         <div className='col-6 text-end' style={{ display: 'flex', alignItems: 'center', justifyContent: "end" }}>
//                                             <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1}
//                                                 style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px' }}>&laquo;</button>
//                                             <button onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1}
//                                                 style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', borderLeft: "none" }}>&lt;</button>
//                                             <button
//                                                 style={{ background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', cursor: 'pointer', fontSize: '24px', width: '3rem', border: '1px solid lightgrey', borderLeft: "none" }}>
//                                                 {currentPage}
//                                             </button>
//                                             <button onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === totalPages}
//                                                 style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', borderLeft: "none" }}>&gt;</button>
//                                             <button onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages}
//                                                 style={{ backgroundColor: 'white', color: 'black', border: '1px solid lightgrey', cursor: 'pointer', fontSize: '24px', borderLeft: "none" }}>&raquo;</button>
//                                         </div>
//                                     </div>
//                                 </div>

//                             </div>
//                         </div>
//                     </div>

//                     {
//                         selectedProposal && (
//                             <div
//                                 onClick={() => setSelectedProposal(null)}
//                                 style={{
//                                     position: 'fixed',
//                                     top: 0, left: 0,
//                                     width: '100vw',
//                                     height: '100vh',
//                                     backgroundColor: 'rgba(0, 0, 0, 0.84)',
//                                     display: 'flex',
//                                     justifyContent: 'center',
//                                     alignItems: 'center',
//                                     zIndex: 9999
//                                 }}
//                             >
//                                 <div
//                                     onClick={(e) => e.stopPropagation()}
//                                     style={{
//                                         backgroundColor: 'white',
//                                         padding: '40px 40px',
//                                         borderRadius: '20px',
//                                         width: '50%',
//                                         maxHeight: '90vh',
//                                         overflow: "hidden",
//                                         boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
//                                         position: 'relative'
//                                     }}
//                                 >

//                                     <div className="col-12">

//                                         <div className="col-12  mb-3">
//                                             <div className="row">
//                                                 <div className="col-6">
//                                                     <h5 className='fw-bold'>{t("Technical Sanction Details")}</h5>
//                                                 </div>

//                                                 <div className="col-6" style={{ display: 'flex', justifyContent: 'flex-end' }}>
//                                                     <button
//                                                         onClick={() => setSelectedProposal(null)}
//                                                         style={{
//                                                             width: '32px',
//                                                             height: '32px',
//                                                             borderRadius: '50%',
//                                                             backgroundColor: 'red',
//                                                             border: 'none',
//                                                             display: 'flex',
//                                                             justifyContent: 'center',
//                                                             alignItems: "center",
//                                                             cursor: 'pointer',
//                                                             fontSize: '24px',
//                                                             fontWeight: 'bold',
//                                                             color: 'white',
//                                                             lineHeight: 1
//                                                         }}
//                                                     >
//                                                         ×
//                                                     </button>
//                                                 </div>
//                                             </div>
//                                         </div>

//                                         <div className="col-12" style={{ height: "59vh", overflowX: "hidden", overflowY: "scroll", scrollBehavior: "smooth" }}>
//                                             <table style={{ width: '100%', height: "100%", borderCollapse: 'collapse' }}>
//                                                 <tbody>
//                                                     {Object.entries(selectedProposal).map(([key, value], index) => (
//                                                         <>
//                                                             <tr key={key} style={{ backgroundColor: index % 2 === 0 ? '#2B75D5' : '#cce0f9', border: '1px solid #cce0f9' }}>
//                                                                 <td style={{
//                                                                     fontWeight: 'bold',
//                                                                     padding: '8px',
//                                                                     width: '40%',
//                                                                     backgroundColor: '#2B75D5',
//                                                                     color: 'white',
//                                                                     border: '1px solid #cce0f9'
//                                                                 }}>
//                                                                     {key}
//                                                                 </td>
//                                                                 <td style={{
//                                                                     padding: '8px',
//                                                                     color: "black",
//                                                                     backgroundColor: index % 2 === 0 ? '#E3EBF5' : '#D0DEF1',

//                                                                 }}>
//                                                                     {/* Handle Upload Bill Copy link */}
//                                                                     {key === 'Technical Sanction Copy' && value ? (
//                                                                         <a href={`${apiurl}/TechincalSactionCopy/${value}`} target="_blank" rel="noreferrer">
//                                                                             {value}
//                                                                         </a>
//                                                                     ) : value == null || value == '' ? (
//                                                                         '-'
//                                                                     ) : (
//                                                                         value.toString()
//                                                                     )}
//                                                                 </td>

//                                                             </tr>

//                                                         </>
//                                                     ))}
//                                                 </tbody>
//                                             </table>
//                                         </div>

//                                     </div>

//                                 </div>
//                             </div>
//                         )}
//                 </div>
//             </div>

//         </>

//     )
// }

// export default TechnicalSanctionOutwards;

import React, { useContext, useEffect, useState } from "react";
import AdminContext from "../../StateContext/Application";
import { apiurl } from "../../../../path";
import { useLanguage } from "../../../../lang/langcontext/LanguageContext";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import GooglePagination from "../../styles/GooglePagination";
import { formatDateTime, formatDate } from "../../../../utils/DateFormat";
import CommonFilters from '../../../../utils/CommonFilters';

const TechnicalSanctionOutwards = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const context = useContext(AdminContext);
  const { TechnicalOutwards, GetBudgetHeadInfo, Usermenu, SecureFileFetching, GetMyDepartmentAccess } =
    context;
  const [proposallist, setProposalList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const budgetEstimation = proposallist;
  const [filteredBills, setFilteredBills] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [statusofData, setstatusofData] = useState("");
  const [AllDistrict, setAllDistrict] = useState([]);
  const [TalukasofDistrict, setTalukasofDistrict] = useState([]);
  const [SelectedDistrict, setSelectedDistrict] = useState([]);
  const [SelectedTalukasofDistrict, setSelectedTalukasofDistrict] =
    useState("");
  const [UserRole, setUserRole] = useState("");
  const [typeofData, settypeofData] = useState("District");
  const [loading, setloading] = useState(false);
  const [RoleID, setroleID] = useState(null);
  const billsPerPage = 10;
  const [selectedProposal, setSelectedProposal] = useState(null);
  const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
const [SelectedHeadCode, setSelectedHeadCode] = useState("");
  const [LoggedUserDistrict, setLoggedUserDistrict] = useState("");

const sortedBills = Array.isArray(filteredBills)
    ? [...filteredBills].sort(
        (a, b) => new Date(b.Date) - new Date(a.Date)
      )
    : [];

const currentBills = sortedBills.slice(
    indexOfFirstBill,
    indexOfLastBill
);

  /////////////////
  const [myDepartments, setMyDepartments] = useState([]);
const [selectedDepartment, setSelectedDepartment] = useState("");

useEffect(() => {
  const fetchDepartments = async () => {
    try {
      const response = await GetMyDepartmentAccess();

      setMyDepartments(response?.data?.departments || []);
    } catch (error) {
      console.error("Department fetch error:", error);
      setMyDepartments([]);
    }
  };

  fetchDepartments();
}, []);
const parseIds = (value) => {
  if (value === null || value === undefined || value === "") {
    return [];
  }

  if (Array.isArray(value)) {
    return value.map(Number).filter((id) => Number.isInteger(id) && id > 0);
  }

  return String(value)
    .replace(/[\[\]"]/g, "")
    .split(",")
    .map((id) => Number(id.trim()))
    .filter((id) => Number.isInteger(id) && id > 0);
};
// ////////////////////

const [exportingPDF, setExportingPDF] = useState(false);

// Normal table = current page
// PDF = ALL records, but SAME sorted order
const displayedGRS = exportingPDF
    ? sortedBills
    : currentBills;
  const headerStyle = {
    padding: "12px 16px",
    whiteSpace: "nowrap",
    borderRight: "1px solid #e0e0e0",
    textTransform: "capitalize",
  };
  const proposalEstimate = async () => {
    let data = await TechnicalOutwards("Technical");
    const { status, Tabletype, message } = data;
    if (status) {
      setProposalList(message);
      setUserRole(Tabletype);
    } else {
      alert(message);
    }
    console.log("working for techinicalcount", message);
  };

  const getmenu = async () => {
    try {
      const data = await Usermenu();
      if (!data || typeof data !== "object") {
        console.error("Invalid data:", data);
        return;
      }
      const roleID = data?.Data?.RoleID;
      setroleID(roleID);
      // Logged-in user's district
      setLoggedUserDistrict(data?.Data?.District);
      console.log("sffdsf", data?.Data);
    } catch (error) {
      console.error("Error in AdminNavbar getmenu:", error);
    }
  };
  useEffect(() => {
    proposalEstimate();
    getmenu();
  }, []);

  const totalProposalAmount = filteredBills?.reduce((sum, item) => {
    const amount = Number(item?.TechnicalSanctionAmt);
    return sum + (isNaN(amount) ? 0 : amount);
  }, 0);
  // useEffect(() => {
  //     const lowerSearchTerm = searchTerm.toLowerCase();
  //     const filtered = budgetEstimation.filter(bill =>
  //         Object.values(bill).some((val) =>
  //             (val || '').toString().toLowerCase().includes(lowerSearchTerm)
  //         )
  //     );
  //     setFilteredBills(filtered);
  //     setCurrentPage(1);
  // }, [searchTerm, budgetEstimation]);

  useEffect(() => {
    setSelectedTalukasofDistrict("");
    setSelectedHeadCode("");
  }, [SelectedDistrict]);

  // useEffect(() => {
  //     let filtered = budgetEstimation;

  //     filtered = filtered.filter(item => {
  //         if (SelectedDistrict && item.District !== SelectedDistrict) return false;
  //         if (SelectedTalukasofDistrict && item.Taluka !== SelectedTalukasofDistrict) return false;

  //         if (statusofData) {
  //             if (statusofData === "false") {
  //                 return (
  //                     item.Status !== "Rejected" &&
  //                     (
  //                         item.Approvance1 === statusofData ||
  //                         item.Approvance2 === statusofData ||
  //                         item.Approvance3 === statusofData
  //                     )
  //                 );
  //             }

  //             if (statusofData === "Rejected") {
  //                 return item.Status === "Rejected";
  //             }
  //         }

  //         return true;
  //     });

  //     if (searchTerm.trim()) {
  //         const lower = searchTerm.toLowerCase();
  //         filtered = filtered.filter(item =>
  //             Object.values(item).some(val =>
  //                 String(val ?? "").toLowerCase().includes(lower)
  //             )
  //         );
  //     }

  //     setFilteredBills(filtered);
  //     setCurrentPage(1);

  // }, [
  //     budgetEstimation,
  //     SelectedDistrict,
  //     SelectedTalukasofDistrict,
  //     statusofData,
  //     searchTerm
  // ]);

  // useEffect(() => {
  //     let filtered = budgetEstimation;

  //     // if (SelectedTalukasofDistrict) {
  //     //     filtered = filtered.filter(item => item.Status == statusofData && item.District == SelectedDistrict && item.Taluka == SelectedTalukasofDistrict);
  //     // }

  //     // if (SelectedDistrict) {
  //     //     filtered = filtered.filter(item => item.Status == statusofData && item.District == SelectedDistrict);
  //     // }

  //     // if (statusofData || SelectedDistrict == "" || SelectedTalukasofDistrict == "") {
  //     //     filtered = filtered.filter(item => item.Status == statusofData);
  //     // }

  //     if (SelectedDistrict) {
  //         filtered = filtered.filter(item => item.District == SelectedDistrict);
  //     }

  //     if (SelectedTalukasofDistrict) {
  //         filtered = filtered.filter(item => item.Taluka == SelectedTalukasofDistrict);
  //     }

  //     if (statusofData) {
  //         if (statusofData == "false") {
  //             filtered = filtered.filter(
  //                 item => item.Status !== "Rejected" && (item.Approvance1 == statusofData || item.Approvance2 == statusofData || item.Approvance3 == statusofData)
  //             );
  //         }
  //         else if (statusofData == "Rejected") {
  //             filtered = filtered.filter(item => item.Status === statusofData);
  //         }
  //     }

  //     if (statusofData == "") {
  //         filtered = budgetEstimation;
  //     }

  //     if (searchTerm.trim() !== "") {
  //         const lower = searchTerm.toLowerCase();
  //         filtered = filtered.filter(bill =>
  //             Object.values(bill).some((val) =>
  //                 (val || '').toString().toLowerCase().includes(lower)
  //             )
  //         );
  //     }

  //     setFilteredBills(filtered);
  //     setCurrentPage(1);

  // }, [statusofData, searchTerm, budgetEstimation, SelectedDistrict, SelectedTalukasofDistrict]);
  const [openDistrict, setOpenDistrict] = useState(false);

const allDistricts = [
  ...new Set(
    AllDistrict
      ?.map((d) =>
        d?.District_Marathi?.split("-")[0]?.trim()
      )
      .filter(Boolean)
  )
].sort();

const isAllSelected =
  allDistricts.length > 0 &&
  SelectedDistrict.length === allDistricts.length;

  const toggleAllDistricts = () => {
    setSelectedDistrict(isAllSelected ? [] : allDistricts);
  };
  // 🔹 Toggle single district
  const toggleDistrict = (district) => {
    setSelectedDistrict((prev) =>
      prev.includes(district)
        ? prev.filter((d) => d !== district)
        : [...prev, district],
    );
  };
  useEffect(() => {
    let filtered = [...budgetEstimation];

    if (typeofData === "District" && RoleID === 29) {
      filtered = filtered.filter(
        (item) =>
          item.HeadCode ===
          "3054-2419(Roads and bridge repair maintenance program)",
      );
      console.log("filtered Date 3054", filtered);
    } else if (typeofData === "State" && RoleID === 29) {
      filtered = filtered.filter(
        (item) => item.HeadCode === "2515-1238(MLA Representative)",
      );
    }

        ///////////// 🔹 Department filter (फक्त State)
    // if (UserRole === "State" && selectedDepartment) {
    //   filtered = filtered.filter((item) =>
    //     parseIds(item.DepartmentAccessID).includes(Number(selectedDepartment)),
    //   );
    // }
    if (selectedDepartment !== "") {
  const departmentId = Number(selectedDepartment);

  filtered = filtered.filter((item) => {
    const departmentIds = parseIds(item.DepartmentAccessID);

    return departmentIds.includes(departmentId);
  });
}


    filtered = filtered.filter((item) => {
      // 🔹 District filter (MULTI)
      if (
        SelectedDistrict &&
        SelectedDistrict.length > 0
      ) {
        const itemDistrict =
          item.District || item.District_Marathi || "";

        const districtMatched = SelectedDistrict.some(
          (district) =>
            itemDistrict === district ||
            itemDistrict.startsWith(`${district}-`)
        );

        if (!districtMatched) {
          return false;
        }
      }
      // 🔹 Taluka filter (single – unchanged)
      if (
        SelectedTalukasofDistrict &&
        item.Taluka !== SelectedTalukasofDistrict
      ) {
        return false;
      }

      // 🔹 Head Code filter
      if (SelectedHeadCode && item.HeadCode !== SelectedHeadCode) {
        return false;
      }

      // 🔹 Status filter
      if (statusofData) {
       if (statusofData === "Pending") {
        return (
          item.Approvance2 === "false" ||
          item.Approvance3 === "false"
        );
      }
        if (statusofData === "Approved") {
          return (
            item.Approvance1 === "true" &&
            item.Approvance2 === "true" &&
            item.Approvance3 === "true"
          );
        }
        if (statusofData === "Rejected") {
          return item.Status === "Rejected";
        }
      }

      return true;
    });

    // 🔹 Search filter (last)
    if (searchTerm.trim()) {
      const lower = searchTerm.toLowerCase();
      filtered = filtered.filter((item) =>
        Object.values(item).some((val) =>
          String(val ?? "")
            .toLowerCase()
            .includes(lower),
        ),
      );
    }

    setFilteredBills(filtered);
    setCurrentPage(1);
  }, [
    budgetEstimation,
    SelectedDistrict, // array
    SelectedTalukasofDistrict,
    statusofData,
    searchTerm,
    typeofData,
    SelectedHeadCode,
    selectedDepartment,   // नवीन
    UserRole,             // नवीन
  ]);
  const selectedBillDetails = (BillID) => {
    const result = budgetEstimation
      .filter((item) => item.TS_ID == BillID)
      .map((item) => ({
        "Technical Sanction UID": item.TS_ID,
        "Technical Sanction Number": item.TechnicalSanctionNo,
        "Head Code": item.HeadCode,
        "Proposal Name": item.WorkName,
        "Proposal Year": item.SanctionYear,
        "GR UID": item.GR_UID,
        "Constituency Name": item.ConstituencyName,
        District: item.District,
        Taluka: item.Taluka,
        "Gram Panchayat": item.GramPanchayat,
        "Type of Work": item.TypeofWork,
        "Technical Sanction Amount": item.TechnicalSanctionAmt,
        "Technical Sanction Copy": item.TechnicalSanctionCopy,
        Date: new Date(item.Date).toLocaleString("en-IN"),
      }));

    console.log("------------------", result);
    setSelectedProposal(result[0]);
  };

  const FetchGramPanachayatInfo = async () => {
    try {
      let res = await GetBudgetHeadInfo("null", "AllDistrict");
      // console.log("Data i get:: ", res);
      setAllDistrict(res);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    FetchGramPanachayatInfo();
  }, []);

 useEffect(() => {
  if (UserRole === "State") {
    if (SelectedDistrict?.length > 0) {
      const res = AllDistrict.filter((item) => {
        const itemDistrict = item?.District_Marathi || "";
        return SelectedDistrict.some(
          (district) =>
            itemDistrict === district ||
            itemDistrict.startsWith(`${district}-`)
        );
      });
      setTalukasofDistrict(res);
    } else {
      setTalukasofDistrict([]);
    }
  } else if (LoggedUserDistrict) {
    // District-login user: always show their own district's talukas
    const res = AllDistrict.filter((item) => {
      const itemDistrict = item?.District_Marathi || "";
      return (
        itemDistrict === LoggedUserDistrict ||
        itemDistrict.startsWith(`${LoggedUserDistrict}-`)
      );
    });
    setTalukasofDistrict(res);
  }
}, [SelectedDistrict, AllDistrict, UserRole, LoggedUserDistrict]);

  const exportTableByClassToExcel = async (
    filteredBills,
    filename = "Technical_Sanction_Report.xlsx",
  ) => {
    if (!Array.isArray(filteredBills) || filteredBills.length === 0) {
      alert("No data available");
      return;
    }
    setloading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));
    try {
      let totalTechnicalAmount = 0;

      const excelData = filteredBills.map((proposal, index) => {
        const amount = Number(proposal.TechnicalSanctionAmt || 0);
        totalTechnicalAmount += isNaN(amount) ? 0 : amount;

        return {
"Sr.No": index + 1,
  "Work Name": proposal.WorkName || "-",
  "Job ID": proposal.JOB_ID || "-",

  ...(UserRole === "State" && RoleID != 29
    ? {}
    : { "Head Code": proposal.HeadCode || "-" }),

  "Technical Sanction UID": proposal.TS_ID || "-",
  "MHUID Number": proposal.TechnicalSanctionNo || "-",
  "GR UID": proposal.GR_UID || "-",
  "Year": proposal.SanctionYear || "-",
  "Constituency Name": proposal.ConstituencyName || "-",
  "District": proposal.District || "-",
  "Taluka": proposal.Taluka || "-",
  "Gram Panchayat": proposal.GramPanchayat || "-",
  "Type of Work": proposal.TypeofWork || "-",
  "Technical Sanction Amount": amount,
  "Technical Sanction Copy": proposal.TechnicalSanctionCopy || "No File",

  "Creation Date": proposal.Date
    ? new Date(proposal.Date).toLocaleString("en-IN")
    : "-",

  "Rejected?": proposal.Status === "Rejected" ? "Yes" : "No",

  "Remark": proposal.Remark || "--",

  "Deputy Engineer":
    proposal.Approvance2 === "true"
      ? "Approved"
      : proposal.Approvance2 === "false"
      ? "Pending"
      : "-",

  "Department HOD(EE)":
    proposal.Approvance3 === "true"
      ? "Approved"
      : proposal.Approvance3 === "false"
      ? "Pending"
      : "-"
};
  });

  /* ---- TOTAL ROW ---- */
  excelData.push({
  "Sr.No": "",
  "Work Name": "",
  "Job ID": "",
  ...(UserRole === "State" && RoleID != 29
    ? {}
    : { "Head Code": "" }),
  "Technical Sanction UID": "",
  "MHUID Number": "",
  "GR UID": "",
  "Year": "",
  "Constituency Name": "",
  "District": "",
  "Taluka": "",
  "Gram Panchayat": "",
  "Type of Work": "TOTAL AMOUNT",
  "Technical Sanction Amount": totalTechnicalAmount,
  "Technical Sanction Copy": "",
  "Creation Date": "",
  "Rejected?": "",
  "Remark": "",
  "Deputy Engineer": "",
  "Department HOD(EE)": ""
});

      const worksheet = XLSX.utils.json_to_sheet(excelData);

      worksheet["!cols"] = Object.keys(excelData[0]).map(() => ({ wch: 24 }));
      worksheet["!freeze"] = { xSplit: 0, ySplit: 1 };

      // Autofilter only data rows (exclude TOTAL row)
      worksheet["!autofilter"] = {
        ref: XLSX.utils.encode_range({
          s: { r: 0, c: 0 },
          e: {
            r: excelData.length - 2,
            c: Object.keys(excelData[0]).length - 1,
          },
        }),
      };

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        "Technical Sanction Report",
      );
      XLSX.writeFile(workbook, filename);
    } catch (error) {
      console.error("Excel Export Error:", error);
    } finally {
      setloading(false); // ✅ ALWAYS stop loader
    }
  };
  const downloadTableOnlyAsPDF = async (tableClass, filename, title) => {
    setExportingPDF(true);
    await new Promise((res) => setTimeout(res, 300));

    const table = document.querySelector(`.${tableClass}`);
    if (!table) {
      setExportingPDF(false);
      return;
    }
    setloading(true);
    setExportingPDF(true);

    // 🔥 Allow React to render loader first
    await new Promise((resolve) => setTimeout(resolve, 900));

    try {
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();

      const topMargin = 25;
      const sideMargin = 10;
      const bottomMargin = 15;

      pdf.setFontSize(16);
      pdf.setFont("helvetica", "bold");
      pdf.text(title, pageWidth / 2, 15, { align: "center" });

      const canvas = await html2canvas(table, {
        scale: 1,
        useCORS: true,
        backgroundColor: "#2C78DB",
      });

      const imgWidth = pageWidth - sideMargin * 2;

      // 🔥 Correct pixel-to-mm ratio
      const pxToMm = imgWidth / canvas.width;

      const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
      const usablePageHeightPx = usablePageHeightMm / pxToMm;

      let renderedHeight = 0;
      let pageNumber = 0;

      while (renderedHeight < canvas.height) {
        const sliceHeight = Math.min(
          usablePageHeightPx,
          canvas.height - renderedHeight,
        );

        const pageCanvas = document.createElement("canvas");
        const context = pageCanvas.getContext("2d");

        pageCanvas.width = canvas.width;
        pageCanvas.height = sliceHeight;

        context.drawImage(
          canvas,
          0,
          renderedHeight,
          canvas.width,
          sliceHeight,
          0,
          0,
          canvas.width,
          sliceHeight,
        );

        const imgData = pageCanvas.toDataURL("image/jpeg", 0.9);

        if (pageNumber > 0) pdf.addPage();

        pdf.addImage(
          imgData,
          "JPEG",
          sideMargin,
          topMargin,
          imgWidth,
          sliceHeight * pxToMm,
        );

        renderedHeight += sliceHeight;
        pageNumber++;
      }

      pdf.save(filename);
      setExportingPDF(false);
    } catch (error) {
      console.error("PDF Export Error:", error);
    } finally {
      setExportingPDF(false);
      setloading(false);
    }
  };


//   const downloadTableOnlyAsPDF = async (tableClass, filename, title) => {
//   setloading(true);
//   setExportingPDF(true);

//   // Give React enough time to render ALL records
//   await new Promise((resolve) => setTimeout(resolve, 500));

//   try {
//     const table = document.querySelector(`.${tableClass}`);

//     if (!table) {
//       console.error("PDF table not found");
//       return;
//     }

//     const pdf = new jsPDF("p", "mm", "a4");

//     const pageWidth = pdf.internal.pageSize.getWidth();
//     const pageHeight = pdf.internal.pageSize.getHeight();

//     const topMargin = 25;
//     const sideMargin = 10;
//     const bottomMargin = 15;

//     pdf.setFontSize(16);
//     pdf.setFont("helvetica", "bold");
//     pdf.text(title, pageWidth / 2, 15, {
//       align: "center",
//     });

//     const canvas = await html2canvas(table, {
//       scale: 1,
//       useCORS: true,
//       backgroundColor: "#2C78DB",
//       logging: false,
//     });

//     const imgWidth = pageWidth - sideMargin * 2;

//     const pxToMm = imgWidth / canvas.width;

//     const usablePageHeightMm =
//       pageHeight - topMargin - bottomMargin;

//     const usablePageHeightPx =
//       usablePageHeightMm / pxToMm;

//     let renderedHeight = 0;
//     let pageNumber = 0;

//     while (renderedHeight < canvas.height) {
//       const sliceHeight = Math.min(
//         usablePageHeightPx,
//         canvas.height - renderedHeight
//       );

//       const pageCanvas = document.createElement("canvas");

//       const context = pageCanvas.getContext("2d");

//       pageCanvas.width = canvas.width;
//       pageCanvas.height = sliceHeight;

//       context.drawImage(
//         canvas,
//         0,
//         renderedHeight,
//         canvas.width,
//         sliceHeight,
//         0,
//         0,
//         canvas.width,
//         sliceHeight
//       );

//       const imgData = pageCanvas.toDataURL(
//         "image/jpeg",
//         0.9
//       );

//       if (pageNumber > 0) {
//         pdf.addPage();
//       }

//       pdf.addImage(
//         imgData,
//         "JPEG",
//         sideMargin,
//         topMargin,
//         imgWidth,
//         sliceHeight * pxToMm
//       );

//       renderedHeight += sliceHeight;
//       pageNumber++;
//     }

//     pdf.save(filename);
//   } catch (error) {
//     console.error("PDF Export Error:", error);
//   } finally {
//     setExportingPDF(false);
//     setloading(false);
//   }
// };

  return (
    <>
      <div
        className="col-12 pb-5"
        style={{
          backgroundColor: "#EFF3F8",
          height: "90vh",
          overflowX: "hidden",
          overflowY: "scroll",
          position: "relative",
        }}
      >
        {/* 🔥 Blur Wrapper */}
        <div
          style={{
            filter: loading ? "blur(4px)" : "none",
            pointerEvents: loading ? "none" : "auto",
            transition: "0.2s ease",
          }}
        >
          <div className="col-11 m-auto">
            <div
              className="col-12 px-4 mb-4 mt-3"
              style={{
                filter: loading ? "blur(4px)" : "none",
                pointerEvents: loading ? "none" : "auto",
                transition: "0.2s ease",
              }}
            >
              {/* ================= ROW 1 : HEADING + DOWNLOAD ================= */}
              <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">
                <h5 className="fw-bold d-flex align-items-center m-0">
                  <img
                    src="/Technical-Sanction-Outwards-Blue 64.png"
                    alt="TechnicalSanctionOutwards"
                    style={{
                      width: "24px",
                      height: "24px",
                      marginRight: "6px",
                    }}
                  />
                  {[24, 25, 29, 40, 41].includes(RoleID)
                    ? t("Technical Sanction Status")
                    : t("Technical Sanction Outwards")}
                </h5>
                <div className="d-flex gap-2">
                  <button
                    className="btn btn-success"
                    onClick={() =>
                      exportTableByClassToExcel(
                        sortedBills,
                        "Technical_Sanction_Report.xlsx",
                      )
                    }
                  >
                    {t("Download Excel")}
                  </button>
                  <button
                    className="btn btn-danger"
                    onClick={() =>
                      downloadTableOnlyAsPDF(
                        "TechnicalSanctionoutwards",
                        "TechnicalSanctionoutwards.pdf",
                        "Technical Sanction outwards Report",
                      )
                    }
                  >
                    {t("Download PDF")}
                  </button>
                </div>
              </div>
              
              {/* ////Addded for display filter only for state logins */}
{/* Department Access Filter */}
{myDepartments.length > 1 && (
  <div style={{ width: "250px" }}>
    <select
      className="form-select"
      value={selectedDepartment}
      onChange={(e) => setSelectedDepartment(e.target.value)}
      style={{
        width: "100%",
        padding: "8px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#fff",
        fontSize: "14px",
      }}
    >
      <option value="">{t("All Departments")}</option>

      {myDepartments.map((department) => (
        <option key={department.id} value={department.id}>
          {department.name}
        </option>
      ))}
    </select>
  </div>
)}

              {/* ================= ROW 2 : FILTERS + SEARCH ================= */}
              <CommonFilters
                UserRole={UserRole}

                showDataType={
                  UserRole === "State" && RoleID == 29
                }
                typeofData={typeofData}
                settypeofData={settypeofData}

                showStatus={true}
                statusofData={statusofData}
                setstatusofData={setstatusofData}

                showDistrict={UserRole === "State"}
                SelectedDistrict={SelectedDistrict}
                AllDistrict={AllDistrict}
                openDistrict={openDistrict}
                setOpenDistrict={setOpenDistrict}
                isAllSelected={isAllSelected}
                toggleAllDistricts={toggleAllDistricts}
                handleDistrictToggle={toggleDistrict}

                showHeadCode={UserRole !== "State"}
                selectedHeadCode={SelectedHeadCode}
                setSelectedHeadCode={setSelectedHeadCode}
                headCodeOptions={[
                  ...new Set(
                    budgetEstimation
                      ?.map((item) => item.HeadCode)
                      .filter(Boolean)
                  )
                ].sort()}

                showTaluka={true}
                SelectedTaluka={SelectedTalukasofDistrict}
                setSelectedTaluka={setSelectedTalukasofDistrict}
                TalukasofDistrict={TalukasofDistrict}

                showSearch={true}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
            </div>

            <div className="col-12 pb-5">
              <div
                className="m-auto mb-3"
                style={{
                  backgroundColor: "white",
                  padding: "40px 40px",
                  boxShadow: "0px 0px 5px 1px #E4E8EC",
                  borderRadius: "20px",
                  width: "100%",
                  maxWidth: "100%",
                  overflowX: "hidden",
                }}
              >
             <div  className='col-12 tableDesign'
  style={{
    maxHeight: "600px",
    overflowY: "auto",
    position: "relative",
  }}
>
  <table className='m-0 p-0 TechnicalSanctionoutwards'
    style={{
      width: "100%",
      borderCollapse: "collapse",
    }}
  >
    <thead
      style={{
        position: "sticky",
        top: 0,
        zIndex: 10,
        backgroundColor: "#1976d2",
      }}
    >
                      <tr
                        style={{
                          color: "white",
                          border: "none",
                          height: "3rem",
                          fontSize: "18px",
                        }}
                      >
                        <th style={headerStyle} rowSpan={2} colSpan={1}>
                          {t("Sr.No")}
                        </th>
                        <th
                          style={{ minWidth: "200px", padding: "8px" }}
                          rowSpan={2}
                          colSpan={1}
                        >
                          {t("Work Name")}
                        </th>
                        <th
                          style={{ minWidth: "180px", padding: "8px" }}
                          rowSpan={2}
                          colSpan={1}
                        >
                          {t("Job ID")}
                        </th>
                        {UserRole === "State" && RoleID != 29 ? (
                          ""
                        ) : (
                          <th
                            style={{ minWidth: "230px", padding: "8px" }}
                            rowSpan={2}
                            colSpan={1}
                          >
                            {t("Head Code")}
                          </th>
                        )}
                        {/* changed from 9 to 7 */}
                        <th
                          style={{ minWidth: "180px", padding: "8px" }}
                          rowSpan={2}
                          colSpan={1}
                        >
                          {t("Technical Sanction UID")}
                        </th>
                        <th
                          style={{ minWidth: "150px", padding: "8px" }}
                          rowSpan={2}
                          colSpan={1}
                        >
                          {t("MHUID Number")}
                        </th>
                        <th
                          style={{ minWidth: "150px", padding: "8px" }}
                          rowSpan={2}
                          colSpan={1}
                        >
                          {t("GR UID")}
                        </th>
                        <th
                          style={{ minWidth: "150px", padding: "8px" }}
                          rowSpan={2}
                          colSpan={1}
                        >
                          {t("Year")}
                        </th>
                        <th
                          style={{ minWidth: "150px", padding: "8px" }}
                          rowSpan={2}
                          colSpan={1}
                        >
                          {t("Constituency Name")}
                        </th>
                        <th
                          style={{ minWidth: "150px", padding: "8px" }}
                          rowSpan={2}
                          colSpan={1}
                        >
                          {t("District")}
                        </th>
                        <th
                          style={{ minWidth: "150px", padding: "8px" }}
                          rowSpan={2}
                          colSpan={1}
                        >
                          {t("Taluka")}
                        </th>
                        <th
                          style={{ minWidth: "150px", padding: "8px" }}
                          rowSpan={2}
                          colSpan={1}
                        >
                          {t("Gram Panchayat")}
                        </th>
                        <th
                          style={{ minWidth: "200px", padding: "8px" }}
                          rowSpan={2}
                          colSpan={1}
                        >
                          {t("Type of Work")}
                        </th>
                        <th
                          style={{ minWidth: "230px", padding: "8px" }}
                          rowSpan={2}
                          colSpan={1}
                        >
                          {t("Technical Sanction Amount")}
                        </th>
                        <th
                          style={{ minWidth: "230px", padding: "8px" }}
                          rowSpan={2}
                          colSpan={1}
                        >
                          {t("Technical Sanction Copy")}
                        </th>
                        <th
                          style={{ minWidth: "150px", padding: "8px" }}
                          rowSpan={2}
                          colSpan={1}
                        >
                          {t("Creation Date")}
                        </th>
                        <th
                          style={{ padding: "7px 10px", minWidth: "160px" }}
                          rowSpan={2}
                        >
                          {t("Rejected?")}
                        </th>
                        <th
                          style={{ padding: "7px 10px", minWidth: "160px" }}
                          rowSpan={2}
                        >
                          {t("Remark")}
                        </th>
                        <th
                          style={{ minWidth: "150px", padding: "8px" }}
                          colSpan={2}
                        >
                          {t("Approved by")}
                        </th>{" "}
                        {/* changed from 9 to 7 */}
                        {/* <th style={{ width: "12%", textAlign: "center", border: "1px solid white" }} colSpan={1} rowSpan={2}>Details</th> */}
                      </tr>
                      <tr
                        style={{
                          color: "white",
                          border: "none",
                          height: "3rem",
                        }}
                      >
                        <th style={headerStyle}>{t("Deputy Engineer")}</th>
                        {/* <th style={headerStyle}>{t("Executive Engineer")}</th> */}
                        <th style={headerStyle}>{t("Department HOD(EE)")}</th>
                      </tr>
                    </thead>

                    <tbody>
                      <>
                        {displayedGRS?.length === 0 ? (
                          <tr>
                            <td
                              colSpan="30"
                              style={{
                                textAlign: "center",
                                padding: "20px",
                                backgroundColor: "#f9f9f9",
                              }}
                            >
                              {t("No data available")}
                            </td>
                          </tr>
                        ) : (
                          displayedGRS?.map((proposal, index) => {
                            const bgColor =
                              index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                            return (
                              <tr
                                style={{
                                  backgroundColor: bgColor,
                                  fontSize: "18px",
                                }}
                                key={index}
                              >
                                <td style={{ padding: "8px 8px" }}>
                                  {/* {indexOfFirstBill + index + 1} */}
                                  {exportingPDF ? index + 1 : indexOfFirstBill + index + 1}
                                </td>
                                <td
                                  className="fw-bold"
                                  style={{ fontSize: "18px", padding: "5px" }}
                                >
                                  {proposal.WorkName}
                                </td>
                                <td style={{ padding: "8px 8px" }}>
                                  {proposal.JOB_ID}
                                </td>
                                {UserRole === "State" && RoleID != 29 ? (
                                  ""
                                ) : (
                                  <td style={{ padding: "8px 8px" }}>
                                    {proposal.HeadCode}
                                  </td>
                                )}
                                <td style={{ padding: "8px 8px" }}>
                                  {proposal.TS_ID}
                                </td>
                                <td style={{ padding: "8px 8px" }}>
                                  {proposal.TechnicalSanctionNo}
                                </td>
                                <td style={{ padding: "8px 8px" }}>
                                  {proposal.GR_UID}
                                </td>
                                <td style={{ padding: "8px 8px" }}>
                                  {proposal.SanctionYear}
                                </td>
                                <td style={{ padding: "8px 8px" }}>
                                  {proposal.ConstituencyName}
                                </td>
                                <td style={{ padding: "8px 8px" }}>
                                  {proposal.District}
                                </td>
                                <td style={{ padding: "8px 8px" }}>
                                  {proposal.Taluka}
                                </td>
                                <td style={{ padding: "8px 8px" }}>
                                  {proposal.GramPanchayat}
                                </td>
                                <td style={{ padding: "8px 8px" }}>
                                  {proposal.TypeofWork}
                                </td>
                                <td style={{ padding: "8px 8px" }}>
                                  {/* {proposal.TechnicalSanctionAmt} */}
                                  {Number(proposal.TechnicalSanctionAmt).toLocaleString("en-IN")}
 
                                </td>
                                <td style={{ padding: "8px 8px" }}>
                                  {/* {proposal.TechnicalSanctionCopy ? (
                                                                        <a href={`${apiurl}/TechincalSactionCopy/${proposal.TechnicalSanctionCopy.replace(/\s+/g, "")}`} target="_blank" rel="noreferrer">{proposal.TechnicalSanctionCopy.replace(/\s+/g, "")}</a>
                                                                    ) : (
                                                                        <p className='text-danger my-auto fw-bold'>{t("No File")}</p>
                                                                    )
                                                                    } */}
                                  {proposal.TechnicalSanctionCopy ? (
                                    <a
                                      href={`${apiurl}/TechincalSactionCopy/${proposal.TechnicalSanctionCopy}`}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      {proposal.TechnicalSanctionCopy}
                                    </a>
                                  ) : (
                                    <p className="text-danger my-auto fw-bold">
                                      {t("No File")}
                                    </p>
                                  )}
                                </td>
                                {/* <td style={{ padding: "8px 8px" }}>
  {proposal.TechnicalSanctionCopy ? (
    <span
      onClick={(e) => {
        e.preventDefault();
        SecureFileFetching(
          `TechincalSactionDocs/${proposal.TechnicalSanctionCopy}`,
        );
      }}
      className="text-primary"
      style={{ cursor: "pointer" }}
    >
      {proposal.TechnicalSanctionCopy}
    </span>
  ) : (
    <p className="text-danger my-auto fw-bold">
      {t("No File")}
    </p>
  )}
</td> */}

                                <td style={{ padding: "8px 8px" }}>
                                  {formatDateTime(proposal.Date)}
                                </td>
                                <td style={{ padding: "8px 8px" }}>
                                  {proposal.Status === "Pending" ? "No" : "Yes"}
                                </td>
                                {/* <td style={{ padding: "8px 8px" }}>
                                  {proposal.Remark || "--"}
                                </td> */}
                                <td
                                  style={{
                                    width: "200px",
                                    minWidth: "200px",
                                    maxWidth: "200px",
                                    padding: "8px",
                                    verticalAlign: "middle",
                                  }}
                                >
                                  <div
                                    title={proposal.Remark}
                                    style={{
                                      width: "100%",
                                      maxHeight: "none",
                                      overflow: "visible",
                                      whiteSpace: "normal",
                                      overflowWrap: "anywhere",
                                      wordBreak: "normal",
                                    }}
                                  >
                                    {proposal.Remark || "--"}
                                  </div>
                                </td>
                                <td
                                  style={{
                                    padding: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  {proposal.Approvance2 === "true" ? (
                                    <div
                                      className="m-auto"
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        borderRadius: "6px",
                                        backgroundColor: "#16C60C",
                                        border: "none",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        fontSize: "18px",
                                        color: "white",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                      }}
                                    >
                                      ✓
                                    </div>
                                  ) : proposal.Approvance2 === "false" ? (
                                    <div
                                      className="m-auto"
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        borderRadius: "6px",
                                        backgroundColor: "#dc2626",
                                        border: "none",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        fontSize: "18px",
                                        color: "white",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                      }}
                                    >
                                      ✕
                                    </div>
                                  ) : (
                                    "-"
                                  )}
                                </td>
                                <td
                                  style={{
                                    padding: "8px",
                                    textAlign: "center",
                                  }}
                                >
                                  {proposal.Approvance3 === "true" ? (
                                    <div
                                      className="m-auto"
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        borderRadius: "6px",
                                        backgroundColor: "#16C60C",
                                        border: "none",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        fontSize: "18px",
                                        color: "white",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                      }}
                                    >
                                      ✓
                                    </div>
                                  ) : proposal.Approvance3 === "false" ? (
                                    <div
                                      className="m-auto"
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                        borderRadius: "6px",
                                        backgroundColor: "#dc2626",
                                        border: "none",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        fontSize: "18px",
                                        color: "white",
                                        boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                      }}
                                    >
                                      ✕
                                    </div>
                                  ) : (
                                    "-"
                                  )}
                                </td>
                              </tr>
                            );
                          })
                        )}
                                                             <tr
            style={{
              fontWeight: "600",
              backgroundColor: "#f0f0f0",
              fontSize: "18px",
            }}
          >
            <td colSpan={UserRole === "State"&&RoleID!=29 ?12:13} style={{ textAlign: "right", padding: "8px" }}>
              {t("Page Total")}
            </td>

            <td style={{ padding: "8px" }}  >
              ₹ {totalProposalAmount.toLocaleString("en-IN")}
            </td>

            {/* remaining columns */}
            <td colSpan={UserRole==="State" ?19:20}></td>
          </tr>
                        <tr
                          style={{
                            fontWeight: "600",
                            backgroundColor: "#f0f0f0",
                            fontSize: "18px",
                          }}
                        >
                          <td
                            colSpan={
                              UserRole === "State" && RoleID != 29 ? 12 : 13
                            }
                            style={{ textAlign: "right", padding: "8px" }}
                          >
                            {t("Gross Total")}
                          </td>

                          <td style={{ padding: "8px" }}>
                            ₹ {totalProposalAmount.toLocaleString("en-IN")}
                          </td>

                          {/* remaining columns */}
                          <td colSpan={UserRole === "State" ? 19 : 20}></td>
                        </tr>
                      </>
                    </tbody>
                  </table>
                </div>
                <div className="col-12 mt-4">
                  <div className="row">
                    <div className="col-6">
                      <p className="text-gray-600" style={{ fontSize: "18px" }}>
                        {t("Showing")}{" "}
                        {filteredBills.length > 0 ? indexOfFirstBill + 1 : 0}{" "}
                        {t("to")}{" "}
                        {Math.min(indexOfLastBill, filteredBills?.length)}{" "}
                        {t("of")} {filteredBills?.length} {t("entries")}
                      </p>
                    </div>
                    <div
                      className="col-6 text-end"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "end",
                      }}
                    >
                      <GooglePagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={setCurrentPage}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {selectedProposal && (
            <div
              onClick={() => setSelectedProposal(null)}
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0, 0, 0, 0.84)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <div
                onClick={(e) => e.stopPropagation()}
                style={{
                  backgroundColor: "white",
                  padding: "40px 40px",
                  borderRadius: "20px",
                  width: "50%",
                  maxHeight: "90vh",
                  overflow: "hidden",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
                  position: "relative",
                }}
              >
                <div className="col-12">
                  <div className="col-12  mb-3">
                    <div className="row">
                      <div className="col-6">
                        <h5 className="fw-bold">
                          {t("Technical Sanction Details")}
                        </h5>
                      </div>

                      <div
                        className="col-6"
                        style={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <button
                          onClick={() => setSelectedProposal(null)}
                          style={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "50%",
                            backgroundColor: "red",
                            border: "none",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            cursor: "pointer",
                            fontSize: "24px",
                            fontWeight: "bold",
                            color: "white",
                            lineHeight: 1,
                          }}
                        >
                          ×
                        </button>
                      </div>
                    </div>
                  </div>

                  <div
                    className="col-12"
                    style={{
                      height: "59vh",
                      overflowX: "hidden",
                      overflowY: "scroll",
                      scrollBehavior: "smooth",
                    }}
                  >
                    <table
                      style={{
                        width: "100%",
                        height: "100%",
                        borderCollapse: "collapse",
                      }}
                    >
                      <tbody>
                        {Object.entries(selectedProposal).map(
                          ([key, value], index) => (
                            <>
                              <tr
                                key={key}
                                style={{
                                  backgroundColor:
                                    index % 2 === 0 ? "#2B75D5" : "#cce0f9",
                                  border: "1px solid #cce0f9",
                                }}
                              >
                                <td
                                  style={{
                                    fontWeight: "bold",
                                    padding: "8px",
                                    width: "40%",
                                    backgroundColor: "#2B75D5",
                                    color: "white",
                                    border: "1px solid #cce0f9",
                                  }}
                                >
                                  {key}
                                </td>
                                <td
                                  style={{
                                    padding: "8px",
                                    color: "black",
                                    backgroundColor:
                                      index % 2 === 0 ? "#E3EBF5" : "#D0DEF1",
                                  }}
                                >
                                  {/* Handle Upload Bill Copy link */}
                                  {key === "Technical Sanction Copy" &&
                                  value ? (
                                    <a
                                      href={`${apiurl}/TechincalSactionCopy/${value}`}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      {value}
                                    </a>
                                  ) : value == null || value == "" ? (
                                    "-"
                                  ) : (
                                    value.toString()
                                  )}
                                </td>
                              </tr>
                            </>
                          ),
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {loading && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(255,255,255,0.4)",
              backdropFilter: "blur(2px)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <div className="Adminloader"></div>
          </div>
        )}
      </div>
    </>
  );
};

export default TechnicalSanctionOutwards;
